import React from "react";
import { SERVICES } from "@/data/site";

const SLOGANS = [
  "Bursa'nın Premium Spa Deneyimi",
  "Kese Köpük Bizden Hediye",
  "Sertifikalı Uzman Terapistler",
  "%100 Hijyen Garantisi",
  "4.9/5 Google Puanı",
  "Hediye Çeki ile Sevdiklerinizi Şımartın",
];

export const Marquee = ({ dark = false }) => {
  const items = [];
  SERVICES.forEach((s, i) => {
    items.push(s.title);
    if (SLOGANS[i]) items.push(SLOGANS[i]);
  });

  return (
    <div
      data-testid={dark ? "marquee-dark" : "marquee-light"}
      className={`pv-marquee relative overflow-hidden py-4 md:py-5 select-none ${
        dark
          ? "bg-forest-deep text-bronze-soft border-y border-bronze/25"
          : "bg-cream-warm text-forest-deep border-y border-pv"
      }`}
    >
      <div className="pv-marquee-track flex items-center w-max">
        {[0, 1].map((copy) =>
          items.map((t, i) => (
            <span key={`${copy}-${i}`} className="flex items-center shrink-0" aria-hidden={copy === 1}>
              <span className="text-[12px] md:text-[13px] tracking-[0.3em] uppercase font-medium whitespace-nowrap">
                {t}
              </span>
              <span className={`mx-6 md:mx-10 w-1.5 h-1.5 rotate-45 shrink-0 ${dark ? "bg-bronze-soft/70" : "bg-bronze"}`} />
            </span>
          ))
        )}
      </div>
      <div className={`pointer-events-none absolute inset-y-0 left-0 w-16 md:w-28 bg-gradient-to-r ${dark ? "from-forest-deep" : "from-cream-warm"} to-transparent`} />
      <div className={`pointer-events-none absolute inset-y-0 right-0 w-16 md:w-28 bg-gradient-to-l ${dark ? "from-forest-deep" : "from-cream-warm"} to-transparent`} />
    </div>
  );
};
